import RequestBuilder from '../Lib/Requests';

export default class CommandService {
  api = new RequestBuilder();

  buildAddCommandRequest(templateID, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/command`,
      method: 'post',
      data,
      cancelToken,
    };
  }
  async addCommand(templateID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildAddCommandRequest(templateID, body, cancelToken)
    );
    return data;
  }

  buildEditCommandRequest(templateID, commandID, data, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/command/${commandID}`,
      method: 'put',
      data,
      cancelToken,
    };
  }
  async editCommand(templateID, commandID, body, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildEditCommandRequest(templateID, commandID, body, cancelToken)
    );
    return data;
  }

  buildDeleteCommandRequest(templateID, commandID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/command/${commandID}`,
      method: 'delete',
      cancelToken,
    };
  }
  async deleteCommand(templateID, commandID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildDeleteCommandRequest(templateID, commandID, cancelToken)
    );
    return data;
  }

  buildGetCommandRequest(templateID, commandID, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/v2/template/${templateID}/command/${commandID}`,
      method: 'get',
      cancelToken,
    };
  }
  async getCommand(templateID, commandID, cancelToken) {
    const { data = {} } = await this.api.request(
      this.buildGetCommandRequest(templateID, commandID, cancelToken)
    );
    return data;
  }

  buildCommandHistoryRequest(gatewayID, params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${gatewayID}/job/history`,
      method: 'get',
      params,
      cancelToken,
    };
  }

  async fetchPaginatedCommandHistory(gatewayID, params, cancelToken) {
    const { data } = await this.api.request(
      this.buildCommandHistoryRequest(gatewayID, params, cancelToken)
    );
    return data;
  }
}
